import { css, jsx } from '@emotion/react';
import { useState, useRef, useEffect } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { Text } from '../../display/Text/Text.es.js';
import { TooltipWrapper } from '../../display/TooltipWrapper/TooltipWrapper.es.js';
import PageNavigationRow from './PageNavigationRow.es.js';
import checkIsTruncated from './utils/checkIsTruncated.es.js';

const Styles = {
  textEllipsis: (textColor) => css`
    color: ${Colors[textColor]};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  // The width value for textWrap is 90% of the row width, less the 33px
  // difference in text indentation between the first and second nested
  // rows.
  textWrap: css`
    align-items: center;
    border-left: 1px solid ${Colors.neutral400};
    display: flex;
    flex-direction: row;
    padding: 7px 0px;
    width: calc(90% - 33px);
  `,
  rowContainer: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px 22px 0px 60px;
    position: relative;
  `
};
function NestedThirdRow({ item, onSelect }) {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);
  useEffect(() => {
    setIsTruncated(checkIsTruncated(textRef));
  }, []);
  const InnerContent = ({ hover, selected }) => {
    const textColor = hover || selected ? "blue" : "neutral700";
    const textType = selected ? "paragraph3Semibold" : "paragraph3Medium";
    return jsx(
      "div",
      { css: Styles.rowContainer, "data-zds": true },
      jsx(
        "span",
        { css: Styles.textWrap, "data-zds": true },
        jsx(
          "span",
          { css: Styles.textEllipsis(textColor), ref: textRef, "data-zds": true },
          jsx(
            Text,
            { color: textColor, margin: "0 0 0 8px", type: textType },
            item.title,
            item.count && ` (${item.count})`
          )
        )
      )
    );
  };
  const Content = ({ hover, selected }) => isTruncated ? jsx(TooltipWrapper, { allowMultilineTooltip: true, content: item.count ? `${item.title} (${item.count})` : item.title, isBlock: true, position: "northeast" }, () => jsx(InnerContent, { hover, selected })) : jsx(InnerContent, { hover, selected });
  return jsx(PageNavigationRow, { content: Content, item, onSelect });
}

export { NestedThirdRow as default };
//# sourceMappingURL=NestedThirdRow.es.js.map
